export default __webpack_public_path__ + "static/media/G0000.0f293c22.png";